<div class="tab-gestion-equipe">
	<p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onChangeOnglet($event.index)">
		<p-tabPanel header="Equipe">
			<app-equipe #ongletGestionEquipe></app-equipe>
		</p-tabPanel>
		<p-tabPanel header="Groupe de travail" class="tab-groupe-de-travail">
			<app-groupe-de-travail #ongletGestionEquipe></app-groupe-de-travail>
		</p-tabPanel>
	</p-tabView>
</div>
